/**
 * H5 全局版本信息（发布前请同步 bump package.json version）
 * 构建时由 vite 注入 buildTime / mode，用于控制台确认是否为最新部署。
 */

export const APP_VERSION = {
  /** 与 package.json version 一致，发布前手动递增 */
  version: __APP_VERSION__,
  /** ISO 构建时间，每次 build 自动更新 */
  buildTime: __APP_BUILD_TIME__,
  /** vite --mode：dev | test | stage | prod */
  mode: __APP_BUILD_MODE__,
  name: 'jellytech-deal-vue',
} as const

export type AppVersionInfo = typeof APP_VERSION

declare global {
  interface Window {
    __JELLYTECH_H5_VERSION__?: AppVersionInfo
  }
}

/** 启动时打印版本（生产环境也会输出，便于 VConsole 核对是否新包） */
export function logAppVersion(): void {
  const { name, version, mode, buildTime } = APP_VERSION
  const label = `${name} v${version} [${mode}]`

  console.log(
    '%c JellyTech H5 ',
    'background:#7F54D4;color:#fff;font-weight:bold;padding:2px 6px;border-radius:4px;',
    label,
  )
  console.log('[JellyTech H5] buildTime:', buildTime)
  console.log('[JellyTech H5] version object:', { ...APP_VERSION })

  if (typeof window !== 'undefined') {
    window.__JELLYTECH_H5_VERSION__ = { ...APP_VERSION }
  }
}

/** 启动诊断信息（在 initVConsole 之后调用一次，避免重复打印） */
export function logStartupDiagnostics(): void {
  logAppVersion()
  console.log('[JellyTech H5] api:', import.meta.env.VITE_API_BASE_URL)
  console.log('[JellyTech H5] location:', window.location.href)
}
